import { memo } from "react";
import AssigningTechUser from "./AssigningTechUser";

export const  AssigningMemo = memo((params) => {
    return <AssigningTechUser row={params.row} />;
  });